import { Component, OnInit } from '@angular/core';
import { ApiJobService } from '@app/core/graphql/api-job.service';
import { LoadingService } from '@app/core/services/loading/loading.service';
import { ToastService } from '@app/core/services/toast/toast.service';
import { GetNayaxCheckoutResponse } from '@app/shared/models/userBalance';
import { ModalController, NavParams } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-payment-button',
  templateUrl: './payment-button.component.html',
  styleUrls: ['./payment-button.component.scss'],
})
export class PaymentButtonComponent implements OnInit {

  variable;
  header;
  accountId;
  constructor(
    private modalCtrl: ModalController,
    private apiJobService: ApiJobService,
    private navParams: NavParams,
    private toastService: ToastService,
    private loadingSvc: LoadingService,
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    this.variable = this.navParams.get("variable") || undefined;
    this.header = this.navParams.get("header") || undefined;
    this.accountId = this.navParams.get("accountId") || 0;
  }

  async pay() {
    if (this.variable && this.header) {
      await this.loadingSvc.presentForLongTime(this.translateService.instant("LOADING"));
      try {
        const res: GetNayaxCheckoutResponse =
          await this.apiJobService.getNayaxCheckout(this.variable, this.header, this.accountId);
        if (res?.getNayaxCheckout) {
          const data = res?.getNayaxCheckout;
          if (+data.StatusCode === 400) {
            await this.loadingSvc.dismiss();
            this.toastService.presentErrorToast(data.Message);
          } else if (+data.StatusCode === 200) {
            this.modalCtrl.dismiss(data.TransactionID);
          }
        }
      } catch (error) {
        await this.loadingSvc.dismiss();
        this.modalCtrl.dismiss();
      }
    }
  }

  onClose(){
    this.modalCtrl.dismiss();
  }
}
